/* eslint-disable import/no-cycle */
import api from './api.service';

function index(params) {
  return api.get('/roles', params);
}

export const groupsService = {
  index,
};
